<template>
  <div>
    <a-modal
      title="聚客优客数据上传"
      :maskClosable="false"
      v-model="visible"
      :footer="null"
      width="1400px"
      :bodyStyle="{ height: '80vh', overflow: 'hidden' }"
      @cancel="onCancel"
      style="top: 40px !important;"
    >
      <div class="modal-content">
        <div class="search-bar">
          <div class="search-bar-left">
            <span class="search-label">账务日期：</span>
            <a-date-picker
              v-model="accountDate"
              format="YYYY-MM-DD"
              placeholder="请输入账务日期"
              style="width: 200px"
              @change="handleSearch"
            />
            <a-button
              type="primary"
              style="margin-left: 10px"
              :loading="loading"
              @click="handleSearch"
            >
              搜索
            </a-button>
          </div>
        </div>
        <a-alert
          v-if="errorMsg"
          type="error"
          showIcon
          :message="errorMsg"
          class="error-alert"
        />
        <a-spin v-else :spinning="loading || submitLoading" class="table-spin">
          <div class="table-layout">
            <div class="master-section">
              <div class="table-title">订单</div>
              <div class="master-table">
                <table ref="masterTable">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th
                        v-for="col in masterColumns.slice(1)"
                        :key="col.dataIndex"
                        :class="{
                          'col-personnum': col.dataIndex === 'personnum'
                        }"
                      >
                        {{ col.title }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(record, index) in masterData"
                      :key="record.rowKey || record.billno || index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td
                        v-for="col in masterColumns.slice(1)"
                        :key="col.dataIndex"
                        :class="{
                          'col-personnum': col.dataIndex === 'personnum'
                        }"
                      >
                        <a-input-number
                          v-if="col.dataIndex === 'personnum'"
                          v-model="record.personnum"
                          size="small"
                          :min="0"
                          :precision="0"
                        />
                        <template v-else>
                          {{ renderMasterCell(record, col) }}
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="consume-section">
              <div class="table-title">消费</div>
              <div class="consume-table">
                <table ref="consumeTable">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>代码</th>
                      <th>名称</th>
                      <th>分类</th>
                      <th>数量</th>
                      <th>售价</th>
                      <th>折扣率</th>
                      <th>折扣金额</th>
                      <th>折后单价</th>
                      <th>菜品金额</th>
                      <th>销售类型</th>
                      <th>点菜时间</th>
                      <!-- <th>saleDuctAmt</th>
                    <th>presentPrice</th> -->
                      <th class="col-action">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(record, index) in consumeData"
                      :key="record.rowKey || index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ record.productcode }}</td>
                      <td>{{ record.productname }}</td>
                      <td>{{ record.typename }}</td>
                      <td>{{ record.qty }}</td>
                      <td>
                        <a-input-number
                          v-model="record.sellprice"
                          size="small"
                          :min="0"
                          :precision="2"
                          @change="onConsumeSellPriceChange(record)"
                        />
                      </td>
                      <td>{{ record.discount }}</td>
                      <td>{{ record.discountamt }}</td>
                      <td>{{ record.rrprice }}</td>
                      <td>{{ record.rramt }}</td>
                      <td>{{ record.presentflag }}</td>
                      <td>{{ record.createtime }}</td>
                      <!-- <td>{{ record.saleductamt }}</td>
                    <td>{{ record.presentprice }}</td> -->
                      <td class="col-action">
                        <a-button
                          type="link"
                          size="small"
                          @click="onViewConsumeDetail(record)"
                        >
                          详情
                        </a-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="pay-section">
              <div class="table-title">付款</div>
              <div class="pay-table">
                <table ref="payTable">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>PayId</th>
                      <th>付款方式</th>
                      <th>金额</th>
                      <th>汇率</th>
                      <th>实收金额</th>
                      <th>找零金额</th>
                      <th>支付状态</th>
                      <th>创建时间</th>
                      <th class="col-action">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(record, index) in payData"
                      :key="record.rowKey || index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a-input v-model="record.payid" size="small" />
                      </td>
                      <td>
                        <a-input v-model="record.payname" size="small" />
                      </td>
                      <td>
                        <a-input-number
                          v-model="record.payamt"
                          size="small"
                          :min="0"
                          :precision="2"
                          @change="onPayAmountChange(record)"
                        />
                      </td>
                      <td>
                        <a-input-number
                          v-model="record.rate"
                          size="small"
                          :min="0"
                          :max="1"
                          :precision="0"
                        />
                      </td>
                      <td>{{ record.rramt }}</td>
                      <td>{{ record.changeamt }}</td>
                      <td>{{ record.paystatus }}</td>
                      <td>{{ record.createtime }}</td>
                      <td class="col-action">
                        <a-button
                          type="link"
                          size="small"
                          @click="onViewPayDetail(record)"
                        >
                          详情
                        </a-button>
                        <a-button
                          type="link"
                          size="small"
                          style="margin-left: 10px"
                          @click="onDeletePayItem(index)"
                        >
                          删除
                        </a-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </a-spin>
        <div class="modal-footer">
          <a-button
            type="primary"
            :disabled="!!errorMsg || loading || submitLoading"
            @click="onAddPayItem"
          >
            新增付款项
          </a-button>
          <div class="modal-footer-right">
            <a-button @click="onCancel">取消</a-button>
            <a-button
              type="primary"
              :disabled="!!errorMsg || submitLoading"
              :loading="submitLoading"
              @click="onConfirm"
            >
              提交
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="consumeDetailVisible"
      :footer="null"
      width="900px"
      :maskClosable="false"
    >
      <template slot="title">
        <span>消费详情</span>
        <span class="consume-detail-total">
          ¥ {{ formatAmount(consumeDetailTotal) }}
        </span>
      </template>
      <a-table
        :columns="consumeDetailColumns"
        :data-source="consumeDetailList"
        :pagination="false"
        size="small"
        bordered
        row-key="rowKey"
      />
    </a-modal>
    <a-modal
      v-model="payDetailVisible"
      :footer="null"
      width="900px"
      :maskClosable="false"
    >
      <template slot="title">
        <span>付款详情</span>
        <span class="consume-detail-total">
          ¥ {{ formatAmount(payDetailTotal) }}
        </span>
      </template>
      <a-table
        :columns="consumeDetailColumns"
        :data-source="payDetailList"
        :pagination="false"
        size="small"
        bordered
        row-key="rowKey"
      />
    </a-modal>
  </div>
</template>

<script>
import { cache } from "@/utils/common";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "JuYouJuKeModal",
  data() {
    return {
      visible: false,
      loading: false,
      submitLoading: false,
      accountDate: "",
      defaultAccountDate: "",
      masterData: [],
      consumeData: [],
      payData: [],
      payDefaultTemplate: {
        paystatus: "",
        createtime: "",
        changeamt: undefined
      },
      errorMsg: "",
      pmsAccounts: [],
      consumeDetailVisible: false,
      payDetailVisible: false,
      currentPayDetailPayId: null,
      consumeDetailColumns: [
        {
          title: "账项",
          dataIndex: "AccountItemName",
          align: "center"
        },
        {
          title: "单据号",
          dataIndex: "BillNo",
          align: "center"
        },
        {
          title: "金额",
          dataIndex: "FinalPrice",
          align: "center"
        },
        {
          title: "订单号",
          dataIndex: "OrderNo",
          align: "center"
        }
      ],
      masterColumns: [
        {
          title: "序号",
          width: 50,
          align: "center",
          customRender: (text, record, index) => index + 1
        },
        {
          title: "订单号",
          width: 140,
          align: "center",
          dataIndex: "billno"
        },
        {
          title: "单据时间",
          width: 150,
          align: "center",
          dataIndex: "billdate"
        },
        {
          title: "用餐人数",
          width: 80,
          align: "center",
          dataIndex: "personnum"
        },
        {
          title: "菜品金额",
          width: 100,
          align: "center",
          dataIndex: "retailamt"
        },
        {
          title: "应收金额",
          width: 100,
          align: "center",
          dataIndex: "amt"
        },
        {
          title: "优惠金额",
          width: 100,
          align: "center",
          dataIndex: "dscamt"
        },
        {
          title: "加收金额",
          width: 100,
          align: "center",
          dataIndex: "addamt"
        },
        {
          title: "付款金额",
          width: 100,
          align: "center",
          dataIndex: "payment"
        },
        {
          title: "单据类型",
          width: 100,
          align: "center",
          dataIndex: "billtype",
          customRender: text => this.renderBillType(text)
        },
        {
          title: "销售类型",
          width: 100,
          align: "center",
          dataIndex: "opertype",
          customRender: text => this.renderOperType(text)
        },
        {
          title: "找零金额",
          width: 100,
          align: "center",
          dataIndex: "changeamt"
        },
        {
          title: "减免金额",
          width: 100,
          align: "center",
          dataIndex: "roundamt"
        },
        {
          title: "服务费",
          width: 100,
          align: "center",
          dataIndex: "serviceamt"
        },
        {
          title: "低消",
          width: 100,
          align: "center",
          dataIndex: "lowamt"
        }
      ]
    };
  },
  computed: {
    consumeDetailList() {
      return this.getPmsAccountDetailsByType("D");
    },
    consumeDetailTotal() {
      return this.consumeDetailList.reduce(
        (sum, item) => sum + (Number(item.FinalPrice) || 0),
        0
      );
    },
    payDetailList() {
      if (
        this.currentPayDetailPayId == null ||
        this.currentPayDetailPayId === ""
      ) {
        return [];
      }
      return this.getPmsAccountDetailsByPayId(this.currentPayDetailPayId);
    },
    payDetailTotal() {
      return this.payDetailList.reduce(
        (sum, item) => sum + (Number(item.FinalPrice) || 0),
        0
      );
    }
  },
  created() {
    const accountDate = cache.get("user").AccountDate;
    this.defaultAccountDate = moment(accountDate).subtract(1, "days");
    this.accountDate = this.defaultAccountDate;
  },
  watch: {
    visible(val) {
      if (val) {
        this.accountDate = this.defaultAccountDate;
        this.handleSearch();
      }
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    onCancel() {
      this.visible = false;
    },
    onConfirm() {
      if (!this.accountDate) {
        this.$message.error("请选择账务日期");
        return;
      }
      if (this.errorMsg) {
        return;
      }
      if (!this.validatePayData()) {
        return;
      }

      this.syncMasterFromConsume();
      this.syncMasterFromPay();

      const payload = this.buildSubmitPayload();

      this.submitLoading = true;
      this.loading = true;
      this.$post("JuYouJuKe_Post", payload)
        .then(res => {
          const data = res && res.Data;

          if (data.indexOf("订单号已存在") > -1) {
            this.$message.error(data);
            return;
          }
          this.$message.success("发送成功");
          this.visible = false;
        })
        .finally(() => {
          this.submitLoading = false;
          this.loading = false;
        });
    },
    validatePayData() {
      const list = Array.isArray(this.payData) ? this.payData : [];
      for (let i = 0; i < list.length; i++) {
        const record = list[i];
        const payId = record.payid;
        if (payId == null || String(payId).trim() === "") {
          this.$message.error(`第${i + 1}行付款项【PayId】不能为空`);
          return false;
        }
        if (record.payname == null || String(record.payname).trim() === "") {
          this.$message.error(`第${i + 1}行付款项【付款方式】不能为空`);
          return false;
        }
        if (
          record.payamt === undefined ||
          record.payamt === null ||
          record.payamt === ""
        ) {
          record.payamt = 0;
        }
        if (
          record.rate === undefined ||
          record.rate === null ||
          record.rate === ""
        ) {
          record.rate = 0;
        }
      }
      return true;
    },
    buildSubmitPayload() {
      return cloneDeep({
        t_sale_master: this.cleanSubmitList(this.masterData),
        t_sale_detail: this.cleanSubmitList(this.consumeData),
        t_sale_payway: this.cleanSubmitList(this.payData)
      });
    },
    cleanSubmitList(list) {
      if (Array.isArray(list)) {
        return list.map(item => this.cleanSubmitRow(item));
      }
      if (list && typeof list === "object") {
        return this.cleanSubmitRow(list);
      }
      return list;
    },
    cleanSubmitRow(row) {
      const data = cloneDeep(row);
      delete data.rowKey;
      return data;
    },
    onAddPayItem() {
      this.payData.push(this.createPayRow(this.payData.length));
    },
    onDeletePayItem(index) {
      this.payData.splice(index, 1);
      this.syncMasterFromPay();
    },
    onViewPayDetail(record) {
      const payId = record.payid;
      if (payId == null || payId === "") {
        this.$message.warning("当前PayId 没有对应账务数据");
        return;
      }
      const details = this.getPmsAccountDetailsByPayId(payId);
      if (!details.length) {
        this.$message.warning("当前PayId 没有对应账务数据");
        return;
      }
      this.currentPayDetailPayId = payId;
      this.payDetailVisible = true;
    },
    onViewConsumeDetail(_record) {
      void _record;
      this.consumeDetailVisible = true;
    },
    getPmsAccountDetailsByType(type) {
      const accounts = Array.isArray(this.pmsAccounts) ? this.pmsAccounts : [];
      const typeUpper = String(type).toUpperCase();

      return this.flattenPmsAccountDetails(accounts, account => {
        const accountType = account.type != null ? account.type : account.Type;
        return String(accountType).toUpperCase() === typeUpper;
      });
    },
    getPmsAccountDetailsByPayId(payId) {
      const accounts = Array.isArray(this.pmsAccounts) ? this.pmsAccounts : [];
      const targetPayId = String(payId);

      return this.flattenPmsAccountDetails(accounts, account => {
        const accountPayId =
          account.payId != null
            ? account.payId
            : account.PayId != null
            ? account.PayId
            : account.payid;
        return accountPayId != null && String(accountPayId) === targetPayId;
      });
    },
    flattenPmsAccountDetails(accounts, predicate) {
      const list = [];

      accounts.forEach((account, accountIndex) => {
        if (!predicate(account)) {
          return;
        }
        const details = account.Details || account.details || [];
        const detailArr = Array.isArray(details) ? details : [details];
        detailArr.forEach((item, index) => {
          if (!item) {
            return;
          }
          list.push({
            ...item,
            rowKey: `${accountIndex}_${index}_${item.BillNo ||
              item.OrderNo ||
              index}`
          });
        });
      });
      return list;
    },
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return "0.00";
      }
      return num.toFixed(2);
    },
    getMasterRecord() {
      if (!Array.isArray(this.masterData) || !this.masterData.length) {
        return null;
      }
      return this.masterData[0];
    },
    sumListAmount(list, field) {
      const sum = (Array.isArray(list) ? list : []).reduce(
        (total, item) => total + (Number(item[field]) || 0),
        0
      );
      return Number(sum.toFixed(2));
    },
    onConsumeSellPriceChange(record) {
      this.recalcConsumeAmounts(record);
      this.syncMasterFromConsume();
    },
    recalcConsumeAmounts(record) {
      const sellprice = Number(record.sellprice) || 0;
      const qty = Number(record.qty) || 0;
      const discount = Number(record.discount);
      const discountRate =
        Number.isNaN(discount) || discount == null ? 100 : discount;

      // 折扣后单价 = 售价 * 折扣率 / 100
      const rrprice = Number(((sellprice * discountRate) / 100).toFixed(2));
      // 菜品金额 = 售价 * 数量
      const rramt = Number((sellprice * qty).toFixed(2));

      record.rrprice = rrprice;
      record.rramt = rramt;
    },
    syncMasterFromConsume() {
      const master = this.getMasterRecord();
      if (!master) {
        return;
      }
      const total = this.sumListAmount(this.consumeData, "rramt");
      master.retailamt = total;
      master.amt = total;
    },
    onPayAmountChange(record) {
      const payamt = Number(record.payamt) || 0;
      const changeamt = Number(record.changeamt) || 0;
      // 实收金额 = 金额 - 找零金额
      record.rramt = Number((payamt - changeamt).toFixed(2));
      this.syncMasterFromPay();
    },
    syncMasterFromPay() {
      const master = this.getMasterRecord();
      if (!master) {
        return;
      }
      master.payment = this.sumListAmount(this.payData, "payamt");
    },
    renderMasterCell(record, col) {
      const val = record[col.dataIndex];
      if (col.dataIndex === "billtype") {
        return this.renderBillType(val);
      }
      if (col.dataIndex === "opertype") {
        return this.renderOperType(val);
      }
      return val;
    },
    renderBillType(text) {
      if (text == 1 || text === "1") {
        return "线下订单";
      }
      return text;
    },
    renderOperType(text) {
      if (text == 1 || text === "1") {
        return "结账";
      }
      if (text == 3 || text === "3") {
        return "退单";
      }
      return text;
    },
    createPayRow(index) {
      return {
        rowKey: `pay_${Date.now()}_${index}`,
        payid: "",
        payname: "",
        payamt: undefined,
        rate: undefined,
        rramt: undefined,
        changeamt: this.payDefaultTemplate.changeamt,
        paystatus: this.payDefaultTemplate.paystatus,
        createtime: this.payDefaultTemplate.createtime
      };
    },
    initPayDefaultTemplate(payList) {
      const list = Array.isArray(payList) ? payList : [];
      const first = list[0];
      if (!first) {
        this.payDefaultTemplate = {
          paystatus: "",
          createtime: "",
          changeamt: undefined
        };
        return;
      }
      this.payDefaultTemplate = {
        paystatus: first.paystatus != null ? first.paystatus : "",
        createtime: first.createtime != null ? first.createtime : "",
        changeamt: first.changeamt != null ? first.changeamt : undefined
      };
    },
    handleSearch() {
      if (!this.accountDate) {
        this.$message.error("请选择账务日期");
        return;
      }
      const accountDate = moment(this.accountDate).format("YYYY-MM-DD");
      this.loading = true;
      this.$post("JuYouJuKe_SendOrder", {
        AccountDate: accountDate
      })
        .then(res => {
          const data = (res && res.Data) || {};
          if (data.errorMsg) {
            this.errorMsg = data.errorMsg;
            this.masterData = [];
            this.consumeData = [];
            this.payData = [];
            this.pmsAccounts = [];
            this.initPayDefaultTemplate([]);
            return;
          }
          this.errorMsg = "";
          const order = data.Order || {};
          const master = order.t_sale_master || [];

          this.masterData = master;
          this.consumeData = order.t_sale_detail || [];
          this.payData = order.t_sale_payway || [];
          this.initPayDefaultTemplate(this.payData);
          this.pmsAccounts = data.PmsAccounts || [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-bar {
  flex-shrink: 0;
  height: 45px;
  margin-bottom: 0;
  display: flex;
  align-items: center;

  .search-bar-left {
    display: flex;
    align-items: center;
  }

  .search-label {
    margin-right: 4px;
  }
}

.error-alert {
  flex-shrink: 0;
  margin-top: 8px;
}

.modal-footer {
  flex-shrink: 0;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modal-footer-right {
    .ant-btn + .ant-btn {
      margin-left: 8px;
    }
  }
}

.table-spin {
  flex: 1;
  min-height: 0;

  /deep/ .ant-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.table-layout {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .master-section,
  .consume-section {
    flex-shrink: 0;
  }

  .master-table,
  .consume-table,
  .pay-table {
    box-sizing: border-box;
    border: 1px solid #ddd;

    table {
      min-width: 1200px;
      width: 100%;
      border-collapse: collapse;

      th,
      td {
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        white-space: nowrap;
      }

      th:last-child,
      td:last-child {
        border-right: none;
      }

      th {
        padding: 4px 6px;
        text-align: center;
      }

      td {
        padding: 3px;
        text-align: center;
      }

      thead th {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #efefef;
      }
    }
  }

  .master-table,
  .consume-table {
    overflow-x: auto;
    overflow-y: hidden;
    height: auto;
    flex-shrink: 0;

    table thead th {
      position: static;
    }
  }

  .master-table {
    table {
      th.col-personnum,
      td.col-personnum {
        width: 80px;
        max-width: 80px;
      }
    }

    td {
      /deep/ .ant-input-number {
        width: 100%;
      }
    }
  }

  .pay-section {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .pay-table {
    overflow: auto;
    flex: 1;
    min-height: 0;
  }

  .consume-table,
  .pay-table {
    td {
      /deep/ .ant-input,
      /deep/ .ant-input-number {
        width: 100%;
      }
    }

    table {
      th.col-action,
      td.col-action {
        position: sticky;
        right: 0;
        z-index: 1;
        min-width: 90px;
        width: 90px;
        text-align: center;
        vertical-align: middle;
        background: #fff;
        box-shadow: -6px 0 8px -6px rgba(0, 0, 0, 0.12);

        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: 1px;
          background: #ddd;
          pointer-events: none;
        }
      }

      thead th.col-action {
        top: 0;
        z-index: 4;
        background: #efefef;
      }

      td.col-action {
        /deep/ .ant-btn-link {
          padding: 0;
        }
      }
    }
  }

  .pay-table {
    table {
      min-width: 1110px;

      th.col-action,
      td.col-action {
        min-width: 110px;
        width: 110px;
      }

      td.col-action {
        white-space: nowrap;

        /deep/ .ant-btn-link {
          padding: 0 4px;
        }
      }

      th:nth-child(1),
      td:nth-child(1) {
        width: 50px;
      }

      th:nth-child(2),
      td:nth-child(2) {
        width: 100px;
      }

      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(8),
      td:nth-child(8) {
        width: 120px;
      }

      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(6),
      td:nth-child(6),
      th:nth-child(7),
      td:nth-child(7) {
        width: 100px;
      }

      th:nth-child(9),
      td:nth-child(9) {
        width: 140px;
      }
    }
  }

  .consume-table {
    table {
      min-width: 1690px;

      th:nth-child(1),
      td:nth-child(1) {
        width: 50px;
      }

      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(11),
      td:nth-child(11) {
        width: 100px;
      }

      th:nth-child(3),
      td:nth-child(3) {
        width: 120px;
      }

      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(6),
      td:nth-child(6),
      th:nth-child(8),
      td:nth-child(8),
      th:nth-child(9),
      td:nth-child(9),
      th:nth-child(10),
      td:nth-child(10),
      th:nth-child(13),
      td:nth-child(13),
      th:nth-child(14),
      td:nth-child(14) {
        width: 90px;
      }

      th:nth-child(7),
      td:nth-child(7) {
        width: 80px;
      }

      th:nth-child(12),
      td:nth-child(12) {
        width: 140px;
      }
    }
  }

  .table-title {
    margin: 6px 0;
    padding-left: 8px;
    font-weight: 600;
    border-left: 4px solid #1890ff;
  }
}

.consume-detail-total {
  color: #f5222d;
  font-weight: 700;
  margin-left: 10px;
}
</style>
